import { createSlice } from "@reduxjs/toolkit";

const metalRateSlice = createSlice({
  name: "metalRate",
  initialState: {
    message: null,
    error: null,
    metals: [],
    metalRate: [],
    buyRateList: [],
    sellRateList: [],
    bullionRates: {},
    bullionRateMetals: [],
    states: [],
    liveRates: [],
    loading: false,
  },
  reducers: {
    fetchMetals: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchMetalsSuccess: (state, action) => {
      state.loading = false;
      state.metals = action.payload.flatData;
      state.buyRateList = action.payload.buyRateList;
      state.sellRateList = action.payload.sellRateList;
      state.bullionRates = action.payload.bullionRates;
      state.bullionRateMetals = action.payload.bullionRateMetals || [];
      state.states = action.payload.states || [];
    },
    fetchMetalsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getMetals: (state, action) => {
      state.metals = action.payload;
    },
    setMetals: (state, action) => {
      state.metals = action.payload;
    },
    getBullionRates: (state, action) => {
      state.metalRate = action.payload;
    },
    setBullionRates: (state, action) => {
      state.metalRate = action.payload;
    },
    addBullionRates: () => {},
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearMessage: (state) => {
      state.error = null;
      state.message = null;
    },
    getLiveRates: (state) => {
      state.loading = true;
    },
    getLiveRatesSuccess: (state, action) => {
      state.loading = false;
      state.liveRates = action.payload;
    },
    getLiveRatesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  setMessage,
  addBullionRates = (data) => ({
    type: "ADD_BULLION_RATE",
    payload: data,
  }),
  setMetals,
  getMetals,
  getBullionRates,
  setBullionRates,
  setError,
  clearMessage,
  fetchMetals,
  fetchMetalsSuccess,
  fetchMetalsFailure,
  getLiveRates,
  getLiveRatesSuccess,
  getLiveRatesFailure,
} = metalRateSlice.actions;

export default metalRateSlice.reducer;
